<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DAgeEditor',
  extends: compoment
}
</script>
